import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {FormGroup, ControlLabel, OverlayTrigger, Tooltip} from 'react-bootstrap';
import {isEmpty} from 'lodash/lang';

export class ClickSelectField extends React.Component {
  static propTypes = {
    options: PropTypes.array.isRequired,
    clickableKey: PropTypes.string.isRequired,
    valueKey: PropTypes.string.isRequired,
    hasSelectedEffect: PropTypes.bool.isRequired,
    readOnly: PropTypes.bool.isRequired,
    hasOverlay: PropTypes.bool.isRequired,
  };
  static defaultProps = {
    hasSelectedEffect: false,
    readOnly: false,
    hasOverlay: true,
  };

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const {defaultValue, input, onValueChange} = this.props;
    if (isEmpty(input.value) && !isEmpty(defaultValue)) {
      this.handleChange(defaultValue);
    } else if (!isEmpty(input.value) && onValueChange) {
      onValueChange(input.value);
    }
  }

  handleChange(value) {
    const {onValueChange, input} = this.props;
    input.onChange(value);
    if (onValueChange) {
      onValueChange(value);
    }
  }

  render() {
    const {
      input,
      label,
      options,
      clickableKey,
      valueKey,
      required,
      helpText,
      meta: {error, warning, touched},
      hasSelectedEffect,
      readOnly,
      hasOverlay,
    } = this.props;

    let errorMsg;
    const validationState = (touched && error && 'error') || (warning && 'warning');
    if (validationState) {
      errorMsg = <span className="help-block">{error || warning}</span>;
    }
    const asterisk = required && <span className="form-field-required" />;

    return (
      <FormGroup validationState={validationState}>
        <div className="click-select" onBlur={() => input.onBlur(input.value)}>
          <ControlLabel>
            {label}
            {asterisk}
          </ControlLabel>
          {readOnly ? (
            <div className="click-select-options">
              {options
                .filter((option) => input.value === option[valueKey])
                .map((option) => {
                  const value = option[valueKey];
                  const clickable = option[clickableKey];
                  return (
                    <span key={value} className="clickable active">
                      {clickable}
                    </span>
                  );
                })}
            </div>
          ) : (
            <div className="click-select-options">
              {options.map((option) => {
                const value = option[valueKey];
                const clickable = option[clickableKey];
                return (
                  <span
                    key={value}
                    className={classNames({
                      clickable: true,
                      'has-effect': hasSelectedEffect,
                      active: input.value === value,
                    })}
                    onClick={() => this.handleChange(value)}
                  >
                    {hasSelectedEffect && hasOverlay ? (
                      <OverlayTrigger placement="top" overlay={<Tooltip id={`tooltip-${value}`}>{value}</Tooltip>}>
                        {clickable}
                      </OverlayTrigger>
                    ) : (
                      clickable
                    )}
                  </span>
                );
              })}
            </div>
          )}
        </div>
        {helpText && <span className="help-text">{helpText}</span>}
        {errorMsg}
      </FormGroup>
    );
  }
}
